import { trans } from '@spotahome/soyuz/client';

import ContractTypesCalendar from './ContractTypesCalendar';

import './ContractTypesDetails.scss';

const ContractTypesDetails = () => {
  const monthlyTitle = trans('contract_types.details.monthly_title');
  const monthlyText = trans('contract_types.details.monthly_text');
  const dailyTitle = trans('contract_types.details.daily_title');
  const dailyText = trans('contract_types.details.daily_text');
  const fortnightlyTitle = trans('contract_types.details.fortnightly.title');
  const fortnightlyText = trans('contract_types.details.fortnightly.text');

  return (
    <section className="contract-types-details">
      <div className="grid__wrapper--inner contract-types-details__row">
        <div className="grid">
          <div className="grid__col grid__col--1-of-3">
            <div className="contract-types__description">
              <h2 className="contract-types__description-title">
                {dailyTitle}
              </h2>
              <p className="contract-types__description-text">{dailyText}</p>
            </div>
          </div>
          <div className="grid__col grid__col--2-of-3">
            <ContractTypesCalendar type="daily" size="medium" />
          </div>
        </div>
      </div>

      <div className="grid__wrapper--inner contract-types-details__row">
        <div className="grid">
          <div className="grid__col grid__col--1-of-3">
            <div className="contract-types__description">
              <h2 className="contract-types__description-title">
                {fortnightlyTitle}
              </h2>
              <p className="contract-types__description-text">
                {fortnightlyText}
              </p>
            </div>
          </div>
          <div className="grid__col grid__col--2-of-3">
            <ContractTypesCalendar type="fortnightly" size="small" />
          </div>
        </div>
      </div>

      <div className="grid__wrapper--inner contract-types-details__row">
        <div className="grid">
          <div className="grid__col grid__col--1-of-3">
            <div className="contract-types__description">
              <h2 className="contract-types__description-title">
                {monthlyTitle}
              </h2>
              <p className="contract-types__description-text">{monthlyText}</p>
            </div>
          </div>
          <div className="grid__col grid__col--2-of-3">
            <ContractTypesCalendar type="monthly" size="medium" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContractTypesDetails;
